import { ApiClient } from '../apiClient';
import { BrandFamily } from '../../types/brandFamily';
import { Card } from '../../types/card';

export class BrandFamilyService {
  constructor(private apiClient: ApiClient) {}

  async getEnabled(): Promise<BrandFamily[]> {
    return this.apiClient.get<BrandFamily[]>('/gift/brand-families');
  }

  async getBySlug(slug: string): Promise<BrandFamily> {
    return this.apiClient.get<BrandFamily>(`/gift/brand-family/${encodeURIComponent(slug)}`);
  }

  async getProducts(slug: string): Promise<Card[]> {
    return this.apiClient.get<Card[]>(`/gift/brand-family/${encodeURIComponent(slug)}/products`);
  }
}
